export default "__VITE_ASSET__ec140b55__"